import { Box3, Vector3 } from "three";

// Use actual visible vertices, rather than transformed local bounding boxes or
// helper origins. This also handles FBX geometry helpers and skinned poses.
export function modelBounds(objects) {
    const bounds = new Box3(), vertex = new Vector3();
    const roots = (Array.isArray(objects) ? objects : [objects]).filter(Boolean);
    const expand = node => {
        if (!node.isMesh || !node.geometry?.attributes.position) return;
        if (node.isSkinnedMesh) node.skeleton.update();
        const count = node.geometry.attributes.position.count;
        for (let index = 0; index < count; index++) {
            node.getVertexPosition(index, vertex).applyMatrix4(node.matrixWorld);
            if ([vertex.x, vertex.y, vertex.z].every(Number.isFinite)) bounds.expandByPoint(vertex);
        }
    };
    for (const root of roots) { root.updateWorldMatrix(true, true); root.updateMatrixWorld(true); root.traverseVisible(expand); }
    // A fully hidden visibility option must still have a usable orbit pivot.
    if (bounds.isEmpty()) for (const root of roots) root.traverse(expand);
    return bounds;
}

export function centerModelOrbit(root, camera, controls) {
    const bounds = modelBounds(root);
    if (bounds.isEmpty()) return false;
    bounds.getCenter(controls.target);
    camera.lookAt(controls.target);
    controls.update();
    return true;
}
